import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";

import EnvironmentPodsMap from "../../environmentPodsMap";

function PodView(props) {
    const params = useParams();
    const [pod, setPod] = useState({
        name: "",
        left: 0,
        middle: 12,
        right: 0
    });

    useEffect(() => {
        if (params.pod == "membership") {
            setPod({ name: params.pod, left: 0, middle: 12, right: 0 });
            props.setMembership(true);
        } else {
            const details = params.pod.split("+");

            const edge = 12 - parseInt(details[1]);
            const side = edge / 2;

            setPod({ name: details[0], left: Math.floor(side), middle: details[1], right: Math.ceil(side) });
            props.setMembership(false);
        }
    }, [params.pod]);

    return (
        <div>
            <Row>
                <Col sm={pod.left}></Col>
                <Col sm={pod.middle}>
                    <EnvironmentPodsMap podCode={pod.name} />
                </Col>
                <Col sm={pod.right}></Col>
            </Row>
        </div>
    );
}

export default PodView;
